import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "px-8 border-end border-2 d-flex justify-content-center align-items-center min-w-auto" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, " Filter By Date: ", -1)
const _hoisted_3 = {
  class: "btn btn-sm d-flex justify-content-between align-items-center dropdown-toggle me-1 dropdown",
  id: "date-filter-dropdown",
  "data-bs-toggle": "dropdown",
  "data-bs-auto-close": "true",
  "aria-expanded": "false"
}
const _hoisted_4 = {
  class: "overflow-hidden dropdown-menu py-0",
  "aria-labelledby": "date-filter-dropdown"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "separator mb-3 opacity-0" }, null, -1)
const _hoisted_6 = { class: "px-3" }
const _hoisted_7 = { class: "px-3" }
const _hoisted_8 = { class: "px-3" }
const _hoisted_9 = { class: "px-3" }
const _hoisted_10 = { class: "px-3" }
const _hoisted_11 = { class: "px-3" }
const _hoisted_12 = { class: "px-3" }
const _hoisted_13 = { class: "px-3" }
const _hoisted_14 = { class: "px-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "separator mt-3 opacity-0" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Datepicker = _resolveComponent("Datepicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("button", _hoisted_3, _toDisplayString(_ctx.predefinedSelection), 1),
    _createElementVNode("ul", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("li", _hoisted_6, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Today")
      ]),
      _createElementVNode("li", _hoisted_7, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Yesterday")
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "This Week")
      ]),
      _createElementVNode("li", _hoisted_9, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Last 7 Days")
      ]),
      _createElementVNode("li", _hoisted_10, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Last Week")
      ]),
      _createElementVNode("li", _hoisted_11, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "This Month")
      ]),
      _createElementVNode("li", _hoisted_12, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Last 31 Days")
      ]),
      _createElementVNode("li", _hoisted_13, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Last Month")
      ]),
      _createElementVNode("li", _hoisted_14, [
        _createElementVNode("a", {
          class: "dropdown-item metronic-dropdown-item menu-link fs-6 metronic-dropdown-text ms-0 cursor-pointer",
          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handlePredefinedDateSelection($event)))
        }, "Custom")
      ]),
      _hoisted_15
    ]),
    _createElementVNode("button", {
      id: "date-range-button",
      class: "btn btn-sm d-flex justify-content-center align-items-center ms-1 position-relative h-100 calendar-button",
      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.openMenuMethod && _ctx.openMenuMethod(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["svg-icon svg-icon-2 m-0 position-absolute top-50 start-50 translate-middle", [{ 'svg-icon-primary': _ctx.isCalendarOpen }]])
      }, [
        _createVNode(_component_inline_svg, {
          src: `${_ctx.originUrl}/assets/svg/icons/general/calendar.svg`
        }, null, 8, ["src"])
      ], 2),
      _createVNode(_component_Datepicker, {
        class: "position-absolute top-50 start-50 translate-middle opacity-0 no-pointer-events z-index-n2 w-0",
        modelValue: _ctx.dateValue,
        "onUpdate:modelValue": [
          _cache[9] || (_cache[9] = ($event: any) => (_ctx.dateValue = $event)),
          _ctx.handleCustomDateSelection
        ],
        ref: "datepicker",
        enableTimePicker: false,
        range: "",
        "max-range": "1095",
        multiCalendars: false,
        onClosed: _ctx.menuCloseHandler,
        altPosition: "",
        position: "center",
        autoPosition: true,
        multiCalendarsSolo: "",
        selectText: "SAVE",
        cancelText: "",
        minDate: new Date('2000-01-01T00:00:00'),
        maxDate: new Date(),
        "prevent-min-max-navigation": true,
        "year-range": [2000, new Date().getFullYear()]
      }, {
        "calendar-header": _withCtx(({ index, day }) => [
          _createElementVNode("div", {
            class: _normalizeClass(index === 5 || index === 6 ? 'text-danger' : '')
          }, _toDisplayString(day), 3)
        ]),
        _: 1
      }, 8, ["modelValue", "onClosed", "onUpdate:modelValue", "minDate", "maxDate", "year-range"])
    ])
  ]))
}